module.exports = __webpack_public_path__ + "img/mu-logo_357x574.3918fe3f.png";